module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AOUL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ANIER")])]), _vm._v(" inclined his head in silent acknowledgment as the attractive airline hostess extended a customary farewell to passengers leaving the aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mouth curved a little wider, and the expression in her eyes offered numerous sensual delights should he choose to extend an invitation to share a drink during her stopover.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The attention she’d bestowed on him during the long international flight had included a friendly warmth that went beyond the courteous solicitousness proffered to his fellow travelers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It could have proved an interesting diversion, if fleeting sexual encounters formed part of his personal agenda, Raoul mused as he cleared the aircraft and entered the concourse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the eldest son and part heir to a billion-dollar fortune, a sense of caution coupled with cynicism had formed at an early age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good European genes had blessed him with enviable height, superb bone structure and ruggedly attractive facial features that inevitably drew a second glance. Physical fitness and fine clothes completed a combination that proved magnetic to women of all ages.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A quality that was both an advantage and a curse, he acknowledged with rueful humor as he rode the escalator down to ground level and crossed to the appropriate luggage carousel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul checked his watch. He had two hours in which to clear customs, take a cab to the hotel at Double Bay, shower and change, before he was scheduled to appear at a business meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Primarily his Australian visit was intended to target the possibility of setting up a Sydney base for the multinational Lanier conglomerate. Wheels had already been set in motion, and if all the details met with his satisfaction, he was prepared to clinch the deal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not easily, for he was a skilled tactician whose strategy was recognized and lauded by his peers and associates.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He spotted his luggage, hefted it from the carousel and then strode out of the terminal to summon a taxi.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brilliant summer sunshine had him reaching for protective sunglasses as he provided the driver with the name of his hotel, then he sank back against the seat in contemplative silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The meeting this afternoon held importance. He planned to present a noncommittal persona, and absent himself from the scene for several days, reachable only by cell phone during a sojourn on Queensland’s Gold Coast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Checking up on family. His mouth thinned slightly as his expression assumed reflective thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("He held filial affection for both his brothers. The ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("youngest, Sebastian, had recently married and was at present taking an extended holiday in Europe with his new wife.")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("However, it was Michel who was providing concern, with his marriage of six months in apparent crisis. Seven weeks ago Michel’s wife had left New York and flown to Australia to take part in a movie being filmed at the Gold Coast Warner Brothers’ studios.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michel had concluded important European meetings, then followed Sandrine with a view to negotiating a reconciliation. The fact the movie had developed financial problems merely added a bargaining dimension Raoul suspected Michel intended to use to his advantage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Each of the Lanier brothers possessed a considerable personal fortune, and sinking a few million dollars into a floundering movie wouldn’t put a dent in Michel’s assets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sudden screech of brakes, a muffled curse from the taxi driver, followed by an offered apology captured his attention, and he caught the buildup of traffic, the terrace houses, as the driver swung into the outer lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul caught a glimpse of tall buildings stretched skyward in the distance, and estimated it would take ten minutes, fifteen at most, to reach the Ritz-Carlton hotel in Double Bay.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("He was no stranger to this large southern hemispheric city, and he held a certain affection for its ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("scenic beauty and stunning architecture, albeit that it was very young in terms of his native France.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Home")]), _vm._v(" was a luxury two-story apartment in Auteuil filled with antique furniture, marble-tiled floors, oriental rugs, objets d’art.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had been born and raised in Paris, graduated from one of its finest universities, then was absorbed into the Lanier corporation as a junior executive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul gave a grim smile in memory of those early days beneath his father’s eaglelike tutelage. Henri Lanier had been a hard taskmaster. Ruthless, Raoul conceded, but fair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Today, Henri presided as the figurehead of a multinational conglomerate, with Raoul and Michel holding equal power. Sebastian, on the other hand, had chosen law, graduated, practiced, then he penned and sold his first novel, and the rest as they say was history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The taxi slid to a halt outside the entrance to a gracious well-established hotel a short distance from the waterfront.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul handed the driver a folded note, then stepped from the vehicle while the concierge collected his bags from the boot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Checking in was a simple procedure, and in his room he took bottled water from the bar-fridge and drank it, ordered room service to deliver lunch at midday, then he unpacked a few essentials, showered, shaved, donned a complimentary robe and replaced the receiver on the last of a few calls less than a minute before a steward presented lunch.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Afterward he dressed, checked his briefcase and took the lift to the main lobby. His meeting was scheduled for two. It was now three minutes past the hour. Essential minutes that gave him an edge, unless the man he was due to liaise with was also well-versed in tactical game-playing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eagerness inevitably bred punctuality, Raoul acknowledged, especially when the possibility of a large investment was at stake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The meeting could easily have stretched to an hour. Raoul cut that time in half with clear instruction and assertive demand, leaving no shred of doubt as to who held command.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Afterward he returned to his room, snagged bottled water from the bar-fridge, then he opened his laptop and spent time keying in data and directing it via e-mail to Paris. He made two calls, the second of which was to Michel, alerting him to his arrival the following day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul flexed his limbs, then stretched his lengthy frame. He needed exercise. The gym? First, he’d exchange the business suit for sweats and sneakers, and take a walk in the fresh air. His plans for the evening encompassed nothing more than ordering in a light evening meal, followed by an hour or two on the laptop, then he intended to fall into bed and catch up on sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The intercom buzzed, and Stephanie reached out to activate it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Michel Lanier is here.’")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She winced at the receptionist’s attempt at a French pronunciation, and stifled a faint smile at the girl’s obvious effort to impress. Michel Lanier was, she had to concede, an impressive man. If a woman was susceptible to a tall, dark-haired, attractive male.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Give me a minute, then show him in.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was an integral part of Stephanie’s job as a marketing manager to initiate discussions and venture opinions. She liked what she did for a living, it paid well and the rewards were many.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was satisfaction in utilizing her expertise in film, together with an instinctive grasp of what attracted and titillated public interest, thus improving cinema attendance, and profitability for the film studios, the investors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This particular movie had gone over budget, over time, financial avenues had been exhausted and a week ago it had been destined not to be completed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The crux had been Sandrine Lanier, part-time model and actress, who had a minor role in the film, and her husband’s willingness to inject a considerable amount of money to salvage it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie shuffled the papers she’d been perusing into a folder at the sound of a double knock on her door, and hit the Save button on her computer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Michel and Raoul Lanier.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She successfully hid her surprise as she registered both names, and she stood and summoned a friendly smile as Michel Lanier entered the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Please take a seat,’ she instructed, indicating a pair of comfortable leather chairs.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My brother requested he sit in at this meeting,’ Michel Lanier revealed smoothly. ‘You have no objection?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What could she say? ‘No, of course not.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michel made the introduction. ‘Stephanie Sommers. Raoul Lanier.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In his late thirties, she surmised, and the elder, if only by a few years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul Lanier stood an inch, maybe closer to two, taller than his brother. His broad frame held a familial similarity, as did his facial features. Except his hair was darker, almost black, and his jaw had the dark shadow of a man who was forced to shave night and morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wide-set gray eyes, dark as slate, were far too knowledgeable for a woman’s peace of mind. As to his mouth…its curve held a sensuality that hinted at great passion. Equally she imagined those lines could thin, perhaps become almost cruel if he was so inclined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His presence in her office hinted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("business,")]), _vm._v(" which raised doubt in her mind that Michel Lanier held the sole stake in a financial package aimed at rescuing the film in which his wife played a minor part.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Stephanie.’ He extended his hand in formal greeting, and she took it, choosing to ignore the faint tinge of mockery evident.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His handshake was firm, his touch warm, and she told herself the sensual awareness pulsing through her veins was merely a figment of her imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mr. Lanier,’ she acknowledged coolly.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One eyebrow rose, and his mouth curved slightly. ‘Raoul.’ He lifted a hand and indicated Michel with an expressive gesture. ‘Otherwise an adherence to formality will prove confusing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His accent was slight, but evident nonetheless, and the depth and intonation of his voice curled around her nerve endings and tugged a little, setting her internal protective mechanism on edge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charm, he had it. There was also knowledge apparent in those dark eyes, a knowledge that was wholly sensual, sexual, coupled with contemplative interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would be lethal with women, she deduced wryly. Given his looks, his physique, his wealth, he wouldn’t even have to try.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With deliberate movements, she crossed around her desk and sank into the leather chair. It was a position of power, and she used it mercilessly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have the figures you requested.’ She looked at Michel, and chose to ignore Raoul entirely. ‘Together with a rundown of proposals we intend to use in promoting the film.’ She picked up a manila envelope and slid papers into it. ‘I’m sure you’ll find it satisfactory. Of course, we can’t begin with promotion until the film is completed. The marketing people will have a private viewing, then discuss which aspects should be highlighted to attract the attention of the viewing public.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("She kept her attention on Michel. ‘I believe the producer anticipates another week should wrap up filming, with perhaps a further few days scheduled ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("for reshooting. It would be of added interest to include you in the publicity campaign…both as an investor, and Sandrine’s husband.’ Her smile was purely professional. ‘I trust you’ll be agreeable?’")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he didn’t respond, she explained, ‘It’s all part of the bid to protect your investment.’ Did she sound cynical? She hadn’t meant to, but it had been a long day. ‘Do you have any questions?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You have another appointment?’ Raoul queried silkily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I do.’ Stephanie glanced at her watch, and stood. ‘I’m sorry I can’t spare you more time.’ She met Michel’s enigmatic gaze, then picked up the manila envelope and held it out to him. ‘When you’ve examined these, please feel free to call me with any queries.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’d like the opportunity to continue this discussion,’ Raoul indicated. ‘Shall we say dinner, tonight? Michel and Sandrine will join us. I’m staying at the Sheraton Mirage. Six-thirty in the main lobby?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It annoyed her unreasonably that he took her acceptance for granted. ‘I’m sorry, I won’t be able to make it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A date you can’t break in the interest of business?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Important business. Or was Raoul Lanier merely employing undue influence in his own interest?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("‘With my daughter, Mr. Lanier, whom I’m due to collect from the day care center in half an hour.’ Her personal file was easily accessible to anyone with the right connections. Eliciting such details would be a ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("breeze for someone of Michel or Raoul Lanier’s standing.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes narrowed fractionally. ‘It isn’t possible for you to hire a baby-sitter?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to hit him for attempting to infringe on her personal life. ‘Difficult, at such short notice,’ she responded stiffly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Make the call, Stephanie.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She disliked being controlled, and she resented this man’s aura of power.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was the temptation to tell him to go to hell, and she barely managed to bite her tongue. Michel Lanier was a wealthy man in his own right, although she couldn’t be certain part of his investment wasn’t being funded by the Lanier conglomerate. In which case, Raoul Lanier had a legitimate claim.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could insist on another evening. In fact, she was sorely tempted to do just that. Except it seemed foolish to be irksome just for the sake of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her expression was cool and composed as she inclined her head. ‘If you’ll excuse me?’ She walked to the door and opened it, waiting as both men filed past her and exited the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One pair of dark gray eyes held a glimmer of amusement, and her own sharpened, then deepened with silent anger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was enjoying this, and didn’t appear to give a second’s consideration to what it would cost her in time and effort.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("She closed the door behind them, then she crossed to her desk and pressed the required digits to connect ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("with the teenage student she relied on to baby-sit. A few minutes later she replaced the receiver, gave a heavy sigh, then walked out to reception.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michel Lanier was using his cell phone, and she was acutely conscious of Raoul’s studied appraisal as she crossed to his side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Six-thirty, the Sheraton Mirage foyer,’ she confirmed, adding with a certain cynicism, ‘I shall look forward to it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He withdrew a slim billfold. ‘My card, with my cell phone number.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to ignore the courtesy, and add with cutting sarcasm that Hell could freeze over before she’d willingly choose to contact him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie caught the quick gleam of amusement apparent, and deliberately arched an eyebrow in silent query, held it, then she accepted the card from his outstretched hand, careful to ensure their fingers didn’t touch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was that an imperceptible quirk of mockery at the edge of his lips? She told herself she didn’t give a damn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without a further word she turned and retraced her steps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was almost five, which allowed her one hour and ten minutes to collect Emma from the day care center, drive to Mermaid Beach, feed and bathe her daughter, then shower, dress, brief the baby-sitter and leave.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Do-able, provided there were no hiccups or delays. ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("An added bonus was that Sarah, her baby-sitter had offered to arrive early and take up any slack.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something for which Stephanie was immensely grateful as she stepped into a slim-fitting black dress and slid the zip home. A few strokes of the brush to her strawberry-blond hair restored order to the stylish bob, and she examined her makeup, added a touch of blusher to her cheeks, spritzed her favorite Hermés perfume to several pulse points, then she slid her feet into stiletto-heeled black pumps, caught up a black shoulder bag and stepped quickly into the lounge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Bye, darling.’ She leaned down and gave Emma a hug. ‘Be a good girl for Sarah.’ She turned toward the baby-sitter. ‘Any problems, ring me on my cell phone. I won’t be late. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thanks,")]), _vm._v("’ she added with heartfelt sincerity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Anytime. Enjoy yourself.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was debatable, Stephanie perceived as she crossed the path and slid in behind the wheel of her car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Business,")]), _vm._v(" she reminded herself as she reversed out from the driveway, and eased the sedan down the quiet suburban street. Tonight is strictly business.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why, then, did she have the feeling that she’d been very cleverly manipulated?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The distance between Mermaid Beach and the Sheraton Mirage hotel at Main Beach represented a fifteen-minute drive…slightly less, if she was fortunate enough to strike a green light at every traffic controlled intersection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("It was a beautiful summer evening, the sun re")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("flected the day’s heat, and Stephanie reached forward to adjust the air conditioning.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("High-rise buildings stood like tall sentinels, vying with luxury hotels lining the long gently curved stretch of oceanfront.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Gold Coast had been her home for almost four years. Years in which she’d mentally fought to put a broken relationship behind her and deal with the bitterness of knowing the man in her life had expected…no, begged, her to terminate an accidental pregnancy on the grounds a baby would represent too much responsibility and wreck his plans. With icy calm she’d handed back his engagement ring and walked out of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It hadn’t been easy. Yet Emma made it all worthwhile. She was a dear child, Stephanie’s image with soft blond curls with the merest tinge of reddish gold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A horn-blast shattered Stephanie’s introspection, and a slight frown creased her forehead as the car developed a faint bump. Seconds later she didn’t know whether to curse or cry as she pulled into the side of the road and brought the vehicle to a halt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just what she needed. A puncture, when she hadn’t allowed herself a minute to spare. Dammit. She reached forward and popped the boot, then she slid out of her seat and prepared to change the tire. Left front, she determined as she removed the jack and set it in position.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Stiletto heels and a figure-hugging dress didn’t make for ideal maneuvering. Nor did she relish wres")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("tling with unfamiliar tools as she attempted to loosen stubborn wheel nuts.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was one occasion when she was more than willing to put feminine self-sufficiency to one side and welcome male assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except no car stopped, and she battled with the task, completed the wheel change, replaced tools and then cleaned up as best she could with a packet of moist wipes and a box of tissues.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A quick glance at her watch confirmed she was already ten minutes late, and she reached for her cell phone, extracted Raoul Lanier’s business card and keyed in the appropriate digits.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He answered on the second ring, and she identified herself, offered an explanation, an apology, and ended the call before he had the opportunity to say a further word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Five minutes later Stephanie slid the car to a halt in the Sheraton Mirage hotel underground car park and took the lift to the main lobby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She saw Raoul at once, his height and breadth of shoulder emphasized by superb tailoring, his dark hair well-groomed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she drew close he turned toward her, and he stood watching her approach with an unwavering scrutiny that made her want to check if there was a smudge on her nose or cheek, and wonder whether her hasty cleaning-up had removed every speck of grease and dust.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Stephanie mentally squared her shoulders as she summoned forth a warm smile. She was practiced in ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("the social graces, and adept at handling any situation. It was very rare for her to allow anything or anyone to ruffle her composure.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All she had to do, she assured herself silently, was get through the next hour or two with her dignity intact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sandrine. Michel,’ she greeted with ease as she joined them. ‘Raoul,’ she acknowledged civilly. ‘I’m sorry about the delay.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Take control,")]), _vm._v(" a tiny voice prompted. ‘Shall we go in?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t miss the faint narrowing of his dark eyes, nor did she mistake the deceptive indolence apparent, and she ignored the slight shiver that feathered its way down her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul Lanier was just a man whose wealth and power were enviable assets in the business arena. She had no interest in him on a personal level, she assured herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why, then, did she feel on edge and about as confident as a seven-year-old child, instead of the twenty-seven-year-old woman she was?")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109e0917","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206700_ch01.vue
// module id = 69
// module chunks = 0